import VueRouter from 'vue-router';

// Vue Templates
import Home from '@/views/Home.vue';
import Blackfriday from '@/views/Blackfriday.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/blackfriday',
        name: 'Blackfriday',
        component: Blackfriday,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
